import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';
import { formatOptionalId } from './memberConstants';

export default function MemberPasswordModal({ open, row, mode = 'login', onClose, onSaved }) {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const isLogin = mode === 'login';
  const title = isLogin ? '修改登入密碼' : '修改交易密碼';

  useEffect(() => {
    if (open) {
      setPassword('');
      setConfirmPassword('');
      setError('');
      setSubmitting(false);
    }
  }, [open, row?.id, mode]);

  if (!open || !row) {
    return null;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    if (!password.trim()) {
      setError('請輸入新密碼');
      return;
    }
    if (password !== confirmPassword) {
      setError('兩次密碼不一致');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await adminApi.memberResetPassword({
        memberId: row.id,
        ...(isLogin ? { password: password.trim() } : { jyPassword: password.trim() }),
      });
      onSaved?.();
      onClose?.();
    } catch (err) {
      setError(err.message || '修改失敗');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div className="admin-modal" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal__header">
          <h3>
            {title} [{formatOptionalId(row.id)}]
          </h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="admin-modal__body">
            <div className="form-field">
              <label htmlFor="memberNewPassword">
                新密碼
                <span className="form-required">*</span>
              </label>
              <input
                id="memberNewPassword"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={submitting}
              />
            </div>
            <div className="form-field">
              <label htmlFor="memberConfirmPassword">
                確認密碼
                <span className="form-required">*</span>
              </label>
              <input
                id="memberConfirmPassword"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                disabled={submitting}
              />
            </div>
            <p className="form-hint form-hint--warn">（ 備註：預設密碼為 abc123 ）</p>
            {error && <div className="alert alert-error">{error}</div>}
          </div>
          <div className="admin-modal__footer">
            <button type="submit" className="btn btn-success" disabled={submitting}>
              {submitting ? '提交中…' : '提交'}
            </button>
            <button
              type="button"
              className="btn btn-warning"
              onClick={() => {
                setPassword('');
                setConfirmPassword('');
              }}
              disabled={submitting}
            >
              重置
            </button>
            <button type="button" className="btn btn-danger" onClick={onClose} disabled={submitting}>
              關閉
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
